export const ASSIGN_PROJECT_TASK_MOUNT_NODE_ID = 'tasks-container';
export const TOOLTIP_MOUNT_NODE_ID = 'tasks-container';
